import '../sass/app.scss';
import GlobalHeader from './components/global/global-header';
import Single from './components/single/single';
import PostList from './components/global/post-list';

const postList = new PostList();
const globalHeader = new GlobalHeader();
const single = new Single();
 